<template>
  <v-card class="mx-auto" outlined="" flat="">
    <v-list-item three-line>
      <v-list-item-avatar tile size="110px">
        <v-img
          :src="course.imglink"
          max-height="110"
          contain
          position="left"
        ></v-img>
      </v-list-item-avatar>
      <v-list-item-content class="pb-1">
        <v-list-item-title class="headline" :title="course.name">{{
          course.name || "No name"
        }}</v-list-item-title>
        <v-list-item-title class="subtitle-1 font-weight-regular">
          {{ course.author || "No Author" }}
        </v-list-item-title>
        <v-list-item-title class="subtitle-1 font-weight-regular">
          {{
            course.content && Array.isArray(course.content)
              ? String(course.content.length)
              : null || "N/A"
          }}
          {{ pluralCheck() ? "Days" : "Day" }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-card-actions class="pl-4 pb-4 pt-0 pr-4">
      <slot name="actions" v-bind:course="course"> </slot>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  name: "courseCard",
  props: {
    course: {
      type: Object,
      required: true,
      validator(value) {
        if (!(typeof value === "object" && value !== null)) {
          return false;
        }
        const REQ_KEYS = ["name", "imglink", "author", "content"];
        return REQ_KEYS.every(val => Object.keys(value).includes(val));
      }
    }
  },
  methods: {
    pluralCheck() {
      return !(
        this.course.content &&
        Array.isArray(this.course.content) &&
        this.course.content.length < 2
      );
    }
  }
};
</script>
